<ngx-json-ld [json]="siteSchema"></ngx-json-ld>
<app-navigation></app-navigation>
<section>
  <router-outlet></router-outlet>
</section>
<app-footer></app-footer>